module.exports = __webpack_public_path__ + "files/a6672fca9536926ea09a9b574001a7d1.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-3.png
// module id = 523
// module chunks = 76